// ? [REVISIT] this should be just 1 piece of the larger generic initial entrypoint file, ex: IE polyfills
const getPublicPath = () => {
  const assetsDir = '/assets/';
  const cdnHost = window.Shopify?.cdnHost ?? 'cdn.shopify.com';
  const AssetUrlParts = [cdnHost, assetsDir];
  const sampleResourceUrl = window.performance
    .getEntriesByType('resource')
    .find((resourceEntry) => AssetUrlParts.every((fragment) => resourceEntry.name.includes(fragment)))?.name;
  if (!sampleResourceUrl) return null;

  const publicPath = `${sampleResourceUrl.split(assetsDir)[0]}${assetsDir}`;
  return publicPath;
};

// -- we should error on the side of caution in favor of PROD
const checkIfLocalDevelopment = () => {
  const inProductionBuildMode = process?.env?.NODE_ENV === 'production';
  const isMainProductionTheme = window?.Shopify?.theme?.role === 'main';

  return !(isMainProductionTheme || inProductionBuildMode);
};

try {
  const isLocalDevelopment = checkIfLocalDevelopment();
  if (isLocalDevelopment) console.log('process.env: ', process.env);
  if (!isLocalDevelopment) {
    let computedPublicPath = window.ASSETS_PUBLIC_PATH || getPublicPath();
    if (!computedPublicPath)
      throw new Error(
        `computedPublicPath is nil: ${computedPublicPath}; window.ASSETS_PUBLIC_PATH: ${window.ASSETS_PUBLIC_PATH}`
      );
    __webpack_public_path__ = computedPublicPath;
  }
} catch (err) {
  console.error('FAILED TO SET PUBLIC PATH FOR WEBPACK', err);
}
export {};

// ? [REVISIT] necessary w/ FAST_REFRESH? what if they opt to turn it off?
//@ts-ignore
if (module?.hot) module?.hot?.accept();
